import { useAnalyticsStudentDashboardEvent } from '../../../hooks/analyticsHooks'

function DashboardAnalytics() {
  useAnalyticsStudentDashboardEvent()

  return null
}

export default DashboardAnalytics
